// Google Analytics tracking utility

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

// Initialize tracker if needed
export const initGA = () => {
  if (typeof window !== 'undefined' && !window.gtag) {
    console.warn('Google Analytics not initialized properly');
  }
};

/**
 * Track page views in Google Analytics
 * @param path - The current path being viewed
 * @param title - Optional page title
 */
export const pageview = (path: string, title?: string) => {
  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }
  
  window.gtag('config', 'G-M3ETYK3DDG', {
    page_path: path,
    page_title: title
  });
};

/**
 * Track custom events in Google Analytics
 * @param action - The action name
 * @param category - Event category
 * @param label - Event label
 * @param value - Event value
 */
export const event = ({ 
  action, 
  category, 
  label, 
  value 
}: { 
  action: string; 
  category?: string; 
  label?: string; 
  value?: number; 
}) => {
  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }
  
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value
  });
}; 